module.exports = __webpack_public_path__ + "img/d9dc724.jpg";